import React from 'react';
import PageHeader from '../../../../components/Headers/PageHeader.jsx';
import GetPaymentsPerDate from "./cards/GetPayments";

const PaymentTools = () => {

    return (
        <div>
            <PageHeader
                title={'Herramientas de pago.'}
                breadcrumb={[{ href: '#', title: 'Herramientas' }]}
            />

            <GetPaymentsPerDate />

        </div>

    )
}

export default PaymentTools;
